import { Injectable } from '@angular/core';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {
  collection(arg0: string) {
    throw new Error("Method not implemented.");
  }
  public online: boolean = true;
  public userId: string;
  public password: string;
  public userName: string;
  public jobName: string;
  public email: any;
  public workYearIn: any;
  public workYearStart: string;
  public slackName: string;
  public companyId: string;
  public type: string;
  public image: string;
  public workTime: string;
  public currentTabName: string;
  public userTaskId: string;
  public spendTime: string;
  public id: string;
  public type_id: string;
  public tid: string;
  public  event: string;
  public  userNameOther: string;
  public  imageOther: string;
  public timesInfoShare = [];
  public requestStartDay: Date;
  public requestEndDay: Date;
  public userIditem: string;
  public date: string;
  public dateBegin: string;
  public dateEnd: string;
  public tuluv_type: string;
  constructor() {
    console.log('Hello DataProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts